import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/core-files/shared.service.';

@Component({
  selector: 'app-subscription-expired',
  templateUrl: './subscription-expired.component.html',
  styleUrls: ['./subscription-expired.component.scss'],
  standalone: false
})
export class SubscriptionExpiredComponent implements OnInit {
  @Input() isFromDialog;
  constructor(private router:Router,private sharedService:SharedService,private matDialog: MatDialog) { }

  ngOnInit() {}
  closeDialog(){
    this.matDialog.closeAll();
  }
  goToSub(){
    this.matDialog.closeAll();
    this.router.navigate(["agent-home/my-account/subscription"]);
  }
}
